//
// Search widget
// -------------

define(function(require) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var core = require('core');
    var tmpl = require('tmpl');
    var device = require('util/device.util');
    var storage = require('util/storage.util');
    var user = require('user');
    var easeOutQuadAlgorithm = require('util/math.util').algorithms.easeOutQuad;
    var scrollManager = require('managers/scroll.manager');

    require('common/jbone.widget');

    return $.widget('search', {

        IOS_LOCATION_BAR_SLIDE_DURATION: 700,
        SCROLL_ANIMATION_DURATION: 300,

        _timer: null,

        options: {
            source: {
                data: [],
                fields: []
            },
            labelField: 'name',
            result: [],
            needle: '',
            type: 'game',
            template: 'search.widget.autocomplete',
            isShowIterator: true
        },

        defaultState: {
            lockBgScroll: device.formFactor !== 'desktop',
            forceInputScroll: device.formFactor !== 'desktop',
            isShowOverlay: device.formFactor !== 'desktop',
            fixIosChromeLocationBarAppearance: device.os === 'ios' && device.browserName === 'chrome',
            fixIosFixedPositionBodyJumps: device.os === 'ios',
            fixIos103InputScrollTop: device.os === 'ios' && parseFloat(device.osVersion) >= 10.3
        },

        init: function(options) {
            _.extend(this.options, options);

            _.extend(this, this.defaultState, {
                isNavigationHappening: false,
                isActive: false,
                lastItemIndex: 0,
                $window: $(window),
                $application: $('#application'),
                $searchInput: this.$('.fn-search-input'),
                $clearButton: this.$('.fn-search-clear'),
                $searchBar: this.$('.fn-search-bar'),
                $overlay: $(tmpl['common.overlay']({ type: 'search' })),
                $portletWrapper: $(this.el.closest('.fn-portlet-wrapper'))
            });

            this.on(this.$searchInput, {
                'focusout': this.handleInputFocusout,
                'keydown': this.handleKeyDown,
                'keyup': this.handleKeyUp
            }, this);

            this.on(this.$el, {
                'tap .fn-search-activate': this.handleActivateTap,
                'tap .fn-search-input': this.handleActivateTap,
                'tap .fn-search-item': this.handleItemTap,
                'tap .fn-search-clear': this.handleClear
            }, this);

            $(window).on('popstate.search', this.deactivateSearch.bind(this));
        },

        destroy: function() {
            this.deactivateSearch();
            $(window).off('.search');
            return $.Widget.prototype.destroy.call(this);
        },

        handleActivateTap: function() {
            this.activateSearch();
            this._fixIosStackingContext();
            this.$searchInput[0].focus();
        },

        handleInputFocus: function() {
            this.activateSearch();
        },

        handleInputFocusout: function() {
            // Fix ios search list, COR-12080
            if (device.os === 'ios' && parseFloat(device.osVersion) >= 10) {
                setTimeout(function() {
                    $(window).trigger('resize');
                }, this.SCROLL_ANIMATION_DURATION);
            }
        },

        _fixIosStackingContext: function() {
            const popupContentEl = document.querySelector('.popup-modal__inner-content');
            const isPopupContainsSearchBar = popupContentEl && popupContentEl.contains(this.$el[0]);

            if (device.os === 'ios' && isPopupContainsSearchBar) {
                this.isActive
                    ? popupContentEl.style.webkitOverflowScrolling = 'auto'
                    : popupContentEl.style.webkitOverflowScrolling = 'touch';
            }
        },

        _scrollToInput: function(callback) {
            if (!this.forceInputScroll) {
                return;
            }

            this._saveInputScroll = document.documentElement.scrollTop || document.body.scrollTop;

            this._fixIosScroll(callback);

            scrollManager.scrollTo(this.$el.offset().top, this.SCROLL_ANIMATION_DURATION, easeOutQuadAlgorithm, callback);
        },

        _scrollFromInput: function(callback) {
            if (!this.forceInputScroll) {
                return;
            }

            this._clearTimer();

            scrollManager.scrollTo(this._saveInputScroll, this.SCROLL_ANIMATION_DURATION, easeOutQuadAlgorithm, callback);
        },

        /**
         * Fixes viewport size change in chrome on ios devices.
         * When an element with position: fixed appears on page Chrome expands location bar with animation and without
         * any signs when that animation ends.
         * So, we set empirical timeout at the moment such element appears and in the end recalculate document scroll.
         * @private
         */
        _fixIosScroll: function(callback) {
            if (!this.fixIosChromeLocationBarAppearance) {
                return;
            }

            clearTimeout(this._timer);
            this._timer = setTimeout(function() {
                scrollManager.scrollTo(this.$el.offset().top, this.SCROLL_ANIMATION_DURATION, easeOutQuadAlgorithm, callback);
            }.bind(this), this.IOS_LOCATION_BAR_SLIDE_DURATION);
        },

        _clearTimer: function() {
            if (!this.fixIosChromeLocationBarAppearance) {
                return;
            }

            clearTimeout(this._timer);
            this._timer = null;
        },

        /**
         * Show clear sign.
         */
        _showClearButton: function() {
            this.$clearButton.addClass('search__clear_active');
        },

        /**
         * Hide clear sign.
         */
        _hideClearButton: function() {
            this.$clearButton.removeClass('search__clear_active');
        },

        /**
         * Add class 'active' on wrapper
         */
        activateSearch: function() {
            if (this.isActive) {
                return;
            }

            this.isActive = true;
            this.$el.addClass('active');
            this.$portletWrapper.addClass('portlet-wrapper--search-enabled');
            this._addOverlay();
            this._scrollToInput(function() {
                this.lockBgScroll && scrollManager.disableScrolling(this);
                this.fixIosFixedPositionBodyJumps && scrollManager.scrollTo(this.$el.offset().top);
                this.fixIos103InputScrollTop && scrollManager.scrollTo(0);
            }.bind(this));
            this.renderDefaultResult();

            this.on(this.$application, {'tap': this.handleApplicationTap}, this);
        },

        /**
         * Disable search
         */
        deactivateSearch: function() {
            if (!this.isActive) {
                return;
            }

            this.isActive = false;

            this.$searchInput.val('');
            this.$el.removeClass('active');
            this.$portletWrapper.removeClass('portlet-wrapper--search-enabled');

            _.extend(this.options, {
                result: [],
                needle: ''
            });

            this.$searchInput[0].blur();
            this._removeOverlay();
            this._hideClearButton();
            this.renderAutocomplete();

            this.lockBgScroll && scrollManager.enableScrolling(this);
            this._scrollFromInput();

            this.off(this.$application);
            this.off(this.$window);
        },

        /**
         * Remove class 'active' from wrapper
         * and reset result
         */
        handleApplicationTap: function(event) {
            if (!this.el.contains(event.target)) {
                this.deactivateSearch();
                this._fixIosStackingContext();
            }
        },

        _addOverlay: function() {
            if (!this.isShowOverlay) {
                return;
            }

            var setOverlaySize = function() {
                this.$overlay.css('height', device.body.height + 'px');
            }.bind(this);

            setOverlaySize();

            this.$overlay.appendTo('#application');
            this.on(this.$window, {'resize': setOverlaySize});
        },

        _removeOverlay: function() {
            if (!this.isShowOverlay) {
                return;
            }

            this.$overlay.remove();
        },

        /**
         * Shows some number of visible results by setting height of auto complete element
         */
        _truncateVisibleResults: function() {
            var $autoComplete = this.$('.fn-autocomplete');

            if (!$autoComplete.length) {
                return;
            }

            var searchAutoCompleteItem = this.$('.fn-search-item')[0];
            var viewPortTopToAutoCompleteHeight = device.realScreenDimensions.height -
                ($autoComplete.offset().top - document.body.scrollTop);
            var visibleItemsCount = this.options.result.length > 5
                    ? Math.max(3, Math.floor(viewPortTopToAutoCompleteHeight / searchAutoCompleteItem.offsetHeight))
                    : this.options.result.length;
            var autoCompleteHeight = Math.min(
                    viewPortTopToAutoCompleteHeight,
                    searchAutoCompleteItem.offsetHeight * visibleItemsCount
                );

            $autoComplete.css('height', autoCompleteHeight + 'px');
        },

        /**
         * Render results from user history
         */
        renderDefaultResult: function() {
            var cachedResult = storage.local.getItem('searchWidgetStorage') || {};
            this.options.result = _.toArray(cachedResult[user.get('userName')] || []);

            if (this.options.result.length) {
                this.options.result.forEach(function(item) {
                    item.selected && delete item.selected;
                });

                this.options.result[0].selected = true;
            }

            this.renderAutocomplete();
        },

        /**
         * Render filtered results
         * @param needle String
         */
        renderFilteredList: function(needle) {
            this.options.needle = needle;
            this.options.result = this._filterSource(this.options.source, this.options.needle);

            if (this.options.result.length) {
                this.options.result.forEach(function(item) {
                    item.selected && delete item.selected;
                });

                this.options.result[0].selected = true;
            }

            this.renderAutocomplete();
        },

        /**
         * Render list with result
         */
        renderAutocomplete: function() {
            this.$('.fn-counter, .fn-autocomplete').remove();

            if (this.options.result.length > 0 && !_.isEqual(this.options.result, this.options.source.data)) {
                if (this.options.isShowIterator) {
                    this.$searchBar.append(tmpl['search.widget.counter'](this.options));
                }

                this.$el.append(tmpl[this.options.template](this.options));

                this._truncateVisibleResults();

                this.on(this.$window, {'resize': this._truncateVisibleResults}, this);
            }
        },

        /**
         * Update selected autocomplete item state
         **/
        updateAutocomplete: function() {
            var selectedClassNames = 'fn-selected search__autocomplete-item_selected';
            var currentItemIndex = _.findIndex(this.options.result, function(item) {
                return item.selected;
            });

            this.$('.fn-search-item').removeClass(selectedClassNames);
            this.$('[data-index="' + currentItemIndex + '"]').addClass(selectedClassNames);

            this._scrollToSelectedItem();
        },

        /**
         * Find results from source
         * @private
         * @param  {Object} hayStack
         * @param  {String} needle
         * @return {Object} result
         */
        _filterSource: function(hayStack, needle) {
            var getFormattedData = function(data, fields) {
                return _.values(_.pick(data, fields));
            };
            var findNeedle = function(data, ndl) {
                return data.filter(function(el) {
                    return ndl && el.trim().toLowerCase().includes(ndl);
                });
            };
            needle = needle.trim().toLowerCase();

            return hayStack.data.filter(function(item) {
                return findNeedle(getFormattedData(item, hayStack.fields), needle).length;
            }).sort(function(a, b) {
                return a.name.indexOf('a') < b.name.indexOf('a') ? -1 : 1;
            });
        },

        /**
         * Scroll screen to selected search result if it's not visible
         * @param  {Boolean} isNavigatingUp
         * @param {HTMLElement} selectedItem
         */
        _scrollScreenToSelectedResult: function(isNavigatingUp, selectedItem) {
            var container = this.$('.fn-autocomplete')[0];

            container.scrollTop = isNavigatingUp
                ? selectedItem.offsetTop
                : selectedItem.offsetTop + selectedItem.offsetHeight - container.offsetHeight;
        },

        /**
         * Navigation to selected item via keys
         */
        _scrollToSelectedItem: function() {
            var $selectedItem = this.$('.fn-selected'),
                currentItemIndex = Number($selectedItem.data('index')),
                isNavigatingUp = currentItemIndex < this.lastItemIndex;
            var isNeedScroll = isNavigatingUp && $selectedItem.parent().offset().top > $selectedItem.offset().top;

            if ($selectedItem.length && (!$selectedItem.isInViewport() || isNeedScroll)) {
                this._scrollScreenToSelectedResult(isNavigatingUp, $selectedItem[0]);
            }

            this.lastItemIndex = currentItemIndex;
        },

        /**
         * Removes text from input by click on clear sign
         */
        handleClear: function() {
            this.$searchInput.val('');

            _.extend(this.options, {
                result: [],
                needle: ''
            });
            this.renderAutocomplete();

            this._hideClearButton();

            this.$searchInput[0].focus();
        },

        /**
         * Keyup handler
         * @param  {Event} event
         */
        handleKeyUp: function(event) {
            !this.isNavigationHappening && this.renderFilteredList(event.target.value);

            event.target.value.length > 0
                ? this._showClearButton()
                : this._hideClearButton();

            this.isNavigationHappening = false;

            if (event.target.value.length) {
                this.$el.trigger($.Event('search:changed', {searchString: event.target.value}));
            }
        },

        /**
         * Keydown handler
         * @param  {Event} event
         */
        handleKeyDown: function(event) {
            var result = this.options.result;
            var index = Math.max(0, _.findIndex(result, function(item) {
                return item.selected;
            }));

            var changeSelection = function(direction) {
                event.preventDefault();
                if (result.length) {
                    this.isNavigationHappening = true;

                    switch (direction) {
                        case 'down':
                            if (index < result.length - 1) {
                                delete result[index].selected;
                                result[index + 1].selected = true;
                            }
                            break;
                        case 'up':
                            if (index > 0) {
                                delete result[index].selected;
                                result[index - 1].selected = true;
                            }
                            break;
                    }
                }
            }.bind(this);

            switch (event.keyCode) {
                case 13:
                    this.goToResult(result[index]);
                    this.deactivateSearch(event);
                    break;
                case 27: // Esc
                    this.deactivateSearch(event);
                    this.$searchInput[0].blur(); // prevent search in inactive state
                    break;
                case 38:
                    changeSelection('up');
                    this.updateAutocomplete();
                    break;
                case 40:
                    changeSelection('down');
                    this.updateAutocomplete();
                    break;
                case 9:
                    if (result.length - 1 === index) {
                        this.deactivateSearch(event);
                    } else {
                        changeSelection('down');
                        this.updateAutocomplete();
                    }

                    break;
                default:
            }
        },

        /**
         * Tap handler
         * @param  {Event} event
         */
        handleItemTap: function(event) {
            this.goToResult(this.options.result[event.currentTarget.dataset.index]);
        },

        /**
         * Action on select item from result
         * @param  {Object} result
         */
        goToResult: function(result) {
            this.deactivateSearch();

            if (result) {
                var message = {
                    ID: 'search',
                    data: {
                        message: 'Search widget output',
                        result: result,
                        type: this.options.type
                    }
                };

                core.trigger('app:message', message);
            }
        }
    });
});
